<template>
  <draft-filter v-if="this.$user.role === 0" :filter="filter" @changeFilter="changeFilter"/>
  <section v-if="!this.loaded">
    <div class="drafts__lists" v-if="drafts && drafts.data.length">
      <draft-card v-for="(draft, key) in this.drafts.data" :draft="draft" :key="key" :draft-key="key" @deleteDraft="deleteDraft"/>
    </div>
    <div v-else class="p-10 text-center text-gray-600 info-panel bg-white rounded">
      Нет записи
    </div>
    <div class="text-center">
      <bootstrap5-pagination class="pagination-outline rounded border p-3 bg-white info-panel" v-if="drafts" :data="drafts" @pagination-change-page="getDrafts"/>
    </div>
    <div class="text-center my-5">
      <span class="text-muted">Черновики хранятся 40 дней, после чего удаляются автоматически.</span>
    </div>
  </section>
  <template v-else>
    <loader-full/>
  </template>
</template>
<script>
  import { Bootstrap5Pagination } from 'laravel-vue-pagination'
  import DraftFilter from '@/components/Draft/DraftFilter'
  import LoaderFull  from '@/components/Main/LoaderFull'
  import DraftCard   from '@/components/Draft/DraftCard'
  import axios       from 'axios'

  export default {
    name: 'Drafts',
    components: {DraftFilter, DraftCard, LoaderFull, Bootstrap5Pagination },
    data () {
      return {
        drafts: null,
        loaded: false,
        filter: {
          insurer: '',
          product: '',
          user: '',
        }
      }
    },
    mounted() {
      this.getDrafts()
    },
    methods: {
      getDrafts(page = 1) {
        this.loaded = true
        let params = null
        if (this.$user.role !== 0) {
          params = {page: page}
        } else {
          this.filter['page'] = page
          params = this.filter
        }
        axios.get('/api/draft/get', { params: params })
            .then(res => {
              this.drafts = Object.assign(res.data, res.data.meta)
              delete this.drafts['meta']
            })
            .catch(err => {console.log(err)})
            .finally(() => this.loaded = false)
      },
      changeFilter(val) {
        if (val.hasOwnProperty('user')) {
          this.filter = val
        }
        this.getDrafts()
      },
      deleteDraft(val) {
        if (confirm(`Удалить черновик №${val[0]}?`)) {
          axios.get('/api/draft/delete/'+val[0])
              .then(res => {
                this.drafts = res.data
              })
              .catch(err => {console.log(err)})
        }
      }
    }
  }
</script>
<style scoped>

</style>